"use client";

import { cn, Icon, Modal, Toggle, Typography } from "@kyan/ui";

import { OneClickTradingModalContent } from "#/app/(desktop)/layouts/Header/components/OneClickTradingModal/components/OneClickTradingModalContent/OneClickTradingModalContent";
import { useOneClickTradingModalController } from "#/app/(desktop)/layouts/Header/components/OneClickTradingModal/OneClickTradingModal.controller";

export const OneClickTradingModal: React.FC = () => {
  const {
    setShowOneClickTradingModal,
    showOneClickTradingModal,
    handleClick,
    isLoading,
    isTradingSessionEnabled,
    isDisabled,
  } = useOneClickTradingModalController();

  return (
    <>
      <label
        htmlFor="one-click-trading"
        className={cn("flex items-center pl-4", {
          "pointer-events-none opacity-50": isLoading,
        })}
      >
        <div className="text-textPrimary flex flex-1 items-center gap-2">
          <Icon size="lg" name="one-click" />
          <Typography>One-Click Trading</Typography>
        </div>

        <Toggle
          size="sm"
          disabled={isDisabled}
          id="one-click-trading"
          value={isTradingSessionEnabled}
          onValueChange={handleClick}
        />
      </label>

      <Modal
        header="Trading Mode"
        open={showOneClickTradingModal}
        onOpenChange={setShowOneClickTradingModal}
      >
        <OneClickTradingModalContent />
      </Modal>
    </>
  );
};
